import requirementModel from "../../models/requirementModel/model";
import requirementDetailModel from "../../models/requirementDetailModel/model";
import requirementService from "../../services/requirementService/service";

export default {
    async addRequirement(requirement) {
        try {
            return await requirementService.addRequirement(requirement);
        } catch (error) {
            console.error('Error adding requirement:', error);
            throw error;
        }
    },
    async updateRequirement(requirement) {
        try {
            return await requirementService.updateRequirement(requirement);
        } catch (error) {
            console.error('Error updating requirement:', error);
            throw error;
        }
    },
    async getAllRequirements(search, page, limit) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const { data, headers } = await requirementService.getAllRequirements(sanitizedSearch, page, limit);
            return {
                data: data.map(requirement => new requirementModel(requirement)),
                total: parseInt(headers['x-total-count'], 10),
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getRequirement(search, page, limit, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const { data, headers } = await requirementService.getRequirement(sanitizedSearch, page, limit, company);
            return {
                data: data.map(requirement => new requirementModel(requirement)),
                total: parseInt(headers['x-total-count'], 10),
            }
        } catch (error) {
            console.error(error);
            throw error;
        }  
    },
    async totalAllRequirements(search, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await requirementService.totalAllRequirements(sanitizedSearch, company);
        } catch (error) {
            console.error('Error fetching requirements:', error);
            throw error;
        }
    },
    async deleteRequirement(id) {
        try {
            return await requirementService.deleteRequirement(id);
        } catch (error) {
            console.error('Error deleting requirement:', error);
            throw error;
        }
    },
    async getOnlyRequirements(id, company) {
        try {
            const { data, headers } = await requirementService.getOnlyRequirements(id, company);
            return {
                data: data[0].map(requirement => new requirementDetailModel(requirement)),
                total: parseInt(headers['x-total-count'], 10),
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async addMappingRequirement(requirement) {
        try {
            return await requirementService.addMappingRequirement(requirement);
        } catch (error) {
            console.error('Error adding requirement:', error);
            throw error;
        }
    },
    async updateStatusCareerDetail(requirement) {
        try {
            return await requirementService.updateStatusCareerDetail(requirement);
        } catch (error) {
            console.error('Error updating requirement:', error);
            throw error;
        }
    },
};